<template>
  <div class="search-group">
    <b-select
      v-model="selecionado"
      name="filtroSelecao"
      class="search-items"
      @select="placeholder = false"
      @input="enviarParaPai()"
    >
      <option
        key="_blank"
        :value="null"
      />

      <option
        v-for="(filtro, index) in filtros"
        :key="index"
        :value="filtro"
        :class="{'opcao-titulo': filtro.titulo}"
        :disabled="filtro.titulo"
      >{{ filtro.label }}</option>
    </b-select>
    <label
      name="filtroLabel"
      for="filter"
      class="fas fa-filter icon"
    />
  </div>
</template>
<style >
.opcao-titulo {
  font-weight: bold;
}
</style>
<script>
export default {
  props: {
    filtros: {
      type: [Array, Boolean],
      default: false,
    },
    filtroInicial: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      placeholder: false,
      selecionado: {},
    }
  },
  created() {
    if (this.filtroInicial) {
      this.selecionado = this.filtroInicial
      this.enviarParaPai()
    }
  },
  methods: {
    enviarParaPai() {
      this.$emit('selecionado', this.selecionado)
    },
  },
}
</script>
